import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import BtnSubmit from '../../../../../Shared/Buttons/BtnSubmit';
import TextInput from '../../../../../Shared/TextInput/TextInput';
import {validateHandler,clearIsValid,clearPhone,blurHandler,changeHandler, addContact, setStripMassage} from '../../../fundialSlice';



const AddContact = (props) => {
    const [openAddContact, setOpenAddContact] = useState(false);

    function toggleAddContactBtn(){
        setOpenAddContact(!openAddContact);
    }

    async function addContactBtn(phoneInputId){
        const phone = props.form.phones[phoneInputId].value;
        if(phone == props.subscriber.cli){
            props.setStripMassage({isShow:true , isErrorMsg: true , message: "הפעולה לא הצליחה" });
        }
        else{
            var result = await props.addContact({subscriber : props.subscriber.cli , songId: props.item.productId  , phoneNumbers: [phone]});
            if(result.payload.errorCode == 0){
                props.setStripMassage({isShow: true , isErrorMsg: false ,  message : "הפעולה בוצעה בהצלחה"});
                props.clearPhone(phoneInputId);
                setOpenAddContact(false);
            }
            else if(result.payload.errorCode != 0 ){
                props.setStripMassage({isShow: true , isErrorMsg: true ,message : "הפעולה לא הצליחה"});
            }
        }
    }

    return (
        <>
        { !openAddContact && <div className="add-contact"  ><button onClick={() => {toggleAddContactBtn()}} className={`add-contact-btn ${ openAddContact && btnId == i ? 'close-contact-btn' : 'open-contact-btn'}`}><span className="btn-text">{openAddContact && btnId == i ? "סגור" : "הוסף איש קשר"}</span></button></div> }    
        { openAddContact &&  
            <div className="wrapper-form-add-contact">
                <div className="input-wrapper">
                    <TextInput
                    className='phone-input'
                    name={'phone-'+props.item.productId}
                    type='number'
                    pattern='[0-9]*'
                    id={'phone-'+props.item.productId}
                    maxLength='10'
                    autoComplete='off'
                    placeholder={'מספר טלפון של איש קשר'}
                    required='required'
                    value={props.form.phones['phone-'+props.item.productId].value}
                    error={props.form.multipleErrors['phone-'+props.item.productId]}
                    onBlur={(e) => props.blurHandler({target: e.target, form: props.form})}
                    onChange={(e) => props.changeHandler({target: e.target, form: props.form})}
                    onWheel={(e) => e.target.blur()}
                    />
                    <button onClick={() => {toggleAddContactBtn()}} className="remove-contact-btn"></button>
                </div>
                <div className="btn-wrapper">
                    <BtnSubmit onclick={() => {addContactBtn('phone-'+props.item.productId)}} text="הוסף איש קשר" formid="fundial-add-contact"></BtnSubmit>
                </div>
            </div> 
        }
        </>
    )
        
}


const mapStateToProps = (state) => {
    return {
        form: state.fundialPage.form,
        subscriber : state.fundialPage.selectedSubscriber,
    };
  };
  
  const mapDispatchToProps = {
    validateHandler,
    clearIsValid,
    clearPhone,
    blurHandler,
    changeHandler,
    addContact,
    setStripMassage
  };
  
  export default connect(mapStateToProps, mapDispatchToProps)(AddContact);